export const STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  INPROGRESS: 'Inprogress',
  COMPLETED: 'COMPLETED',
  Completed: 'Completed',
  PENDING: 'Pending',
  PENDING1: 'PENDING1',
  REJECTED: 'Rejected',
  DRAFT: 'Draft',
  DRAFT1: 'DRAFT',
  Draft: 'Draft',
  ALL: 'All',
  CANCELLED: 'Cancelled',
  REQUESTED: 'REQUESTED',
  REJECTED1: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  SHORTLISTED: 'SHORTLISTED',
  SENT: 'SENT',
  Sent: 'Sent',
  APPROVED: 'APPROVED',
  Approved: 'Approved',
  RECEIVED: 'RECEIVED',
  Received: 'Received',
  PO_CREATED: 'PO_CREATED',
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  'Approval Pending': 'Approval Pending',
  Paid: 'Paid',
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  PAYMENT_IN_PROGRESS: "PAYMENT_IN_PROGRESS",
  PAYMENT_FAILED: "Failed",
  Added: 'Added',
  Unpaid: 'Unpaid',
  PO_NOT_REQUIRED: 'PO_NOT_REQUIRED',
  INVITED: 'Invited',
  'no-answer': 'no-answer',
  'completed': 'completed',
  'failed': 'failed',
  'in-progress': 'in-progress',
  'NOT_PICKED': 'NOT_PICKED',
  ADDITIONAL: 'Added',
  UNPAID: 'Unpaid',
  UNKNOWN: 'Unknown',
  AWAITING_FOR_APPROVAL: 'AWAITING_FOR_APPROVAL',
  QUEUED: 'Queued',
  PROCESSING: 'Processing',
  FAILED: 'Failed',
  REVERSED: 'Reversed',
  SUCCESS: 'Success'
};

export const PAYMENTSTATUSNAMES = {
  ADVANCE_PAYMENT_PENDING: 'No advanced paid',
  ADVANCE_PAYMENT_SUCCESS: 'Advanced paid',
  WORKLOG_SENT: 'Worklog Sent',
  INVOICE_GENERATED: 'Invoice Generated',
  INVOICE_PAID: 'Invoice Paid',
  REFUND_INITIATED: 'Refund Initiated',
  REFUND_COMPLETED: 'Refund Completed',
};

export const PAYMENTSTATUS = {
  ADVANCE_PAYMENT_PENDING: 'ADVANCE_PAYMENT_PENDING',
  ADVANCE_PAYMENT_SUCCESS: 'ADVANCE_PAYMENT_SUCCESS',
  WORKLOG_SENT: 'WORKLOG_SENT',
  INVOICE_GENERATED: 'INVOICE_GENERATED',
  INVOICE_PAID: 'INVOICE_PAID',
  REFUND_INITIATED: 'REFUND_INITIATED',
  REFUND_COMPLETED: 'REFUND_COMPLETED',
};
